import { apiClient } from "../lib/api";

export const payrollApi = {
  listEmployeesForPayroll: () => apiClient.get("/employees/payroll-lookup"),
  dashboardSummary: () => apiClient.get("/payroll/dashboard-summary"),

  // Wage profiles
  listWageProfiles: (employeeId) => apiClient.get("/payroll/wage-profiles", { params: { employee_id: employeeId || undefined } }),
  createWageProfile: (payload) => apiClient.post("/payroll/wage-profiles", payload),
  submitWageProfile: (id) => apiClient.post(`/payroll/wage-profiles/${id}/submit`),
  approveWageProfile: (id) => apiClient.post(`/payroll/wage-profiles/${id}/approve`),
  rejectWageProfile: (id, reason) => apiClient.post(`/payroll/wage-profiles/${id}/reject`, { reason }),
  wageHistory: (employeeId) => apiClient.get(`/payroll/wage-profiles/employee/${employeeId}/history`),

  // Rule registry
  listRules: () => apiClient.get("/payroll/rules"),
  createRule: (payload) => apiClient.post("/payroll/rules", payload),
  approveRule: (id) => apiClient.post(`/payroll/rules/${id}/approve`),
  rejectRule: (id, reason) => apiClient.post(`/payroll/rules/${id}/reject`, { reason }),

  // Periods
  listPeriods: () => apiClient.get("/payroll/periods"),
  getPeriod: (id) => apiClient.get(`/payroll/periods/${id}`),
  createPeriod: (payload) => apiClient.post("/payroll/periods", payload),
  runReadinessCheck: (id) => apiClient.post(`/payroll/periods/${id}/readiness-check`),
  calculatePeriod: (id) => apiClient.post(`/payroll/periods/${id}/calculate`),
  submitForReview: (id) => apiClient.post(`/payroll/periods/${id}/submit-for-review`),
  approvePeriod: (id) => apiClient.post(`/payroll/periods/${id}/approve`),
  returnForCorrection: (id, reason) => apiClient.post(`/payroll/periods/${id}/return-for-correction`, { reason }),
  publishPeriod: (id) => apiClient.post(`/payroll/periods/${id}/publish`),
  generateReports: (id) => apiClient.post(`/payroll/periods/${id}/generate-reports`),
  getCombinedReportUrl: (id) => `${apiClient.defaults.baseURL}/payroll/periods/${id}/combined-report`,

  // Lines / adjustments / disputes
  listLines: (periodId) => apiClient.get(`/payroll/periods/${periodId}/lines`),
  getLine: (lineId) => apiClient.get(`/payroll/lines/${lineId}`),
  addAdjustment: (lineId, payload) => apiClient.post(`/payroll/lines/${lineId}/adjustments`, payload),
  approveAdjustment: (lineId, adjustmentId) => apiClient.post(`/payroll/lines/${lineId}/adjustments/${adjustmentId}/approve`),
  rejectAdjustment: (lineId, adjustmentId, reason) => apiClient.post(`/payroll/lines/${lineId}/adjustments/${adjustmentId}/reject`, { reason }),
  getLineReportUrl: (lineId, reportType) => `${apiClient.defaults.baseURL}/payroll/lines/${lineId}/report?report_type=${reportType}`,
  listDisputes: (periodId) => apiClient.get("/payroll/disputes", { params: { period_id: periodId || undefined } }),
  resolveDispute: (id, payload) => apiClient.post(`/payroll/disputes/${id}/resolve`, payload),

  // Employee self-service
  myLines: () => apiClient.get("/payroll/my/lines"),
  submitDispute: (lineId, description) => apiClient.post(`/payroll/lines/${lineId}/disputes`, { description }),
  getMyLineReportUrl: (lineId, reportType) => `${apiClient.defaults.baseURL}/payroll/my/lines/${lineId}/report?report_type=${reportType}`,
};
